var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_72_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_72_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56824 3.03617 8.69181 1.52242 12.3463C0.0086658 16.0009 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9992 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9943 14.6974 37.8853 9.61368 34.1358 5.8642C30.3863 2.11471 25.3026 0.00573514 20 0ZM20 36.6667C16.7037 36.6667 13.4813 35.6892 10.7405 33.8578C7.99969 32.0265 5.86348 29.4235 4.60202 26.3781C3.34056 23.3326 3.0105 19.9815 3.65359 16.7485C4.29667 13.5155 5.88402 10.5458 8.2149 8.21489C10.5458 5.88401 13.5155 4.29667 16.7485 3.65358C19.9815 3.01049 23.3326 3.34055 26.3781 4.60201C29.4235 5.86347 32.0265 7.99968 33.8578 10.7405C35.6892 13.4813 36.6667 16.7036 36.6667 20C36.6618 24.4188 34.9043 28.6552 31.7798 31.7798C28.6552 34.9043 24.4188 36.6618 20 36.6667Z",
    fill: "#426F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 8.33325C19.5576 8.33325 19.1337 8.50885 18.8212 8.82141C18.5086 9.13397 18.333 9.55789 18.333 9.99992V23.3333C18.333 23.7753 18.5086 24.1992 18.8212 24.5118C19.1337 24.8243 19.5576 24.9999 19.9997 24.9999C20.4417 24.9999 20.8656 24.8243 21.1782 24.5118C21.4907 24.1992 21.6663 23.7753 21.6663 23.3333V9.99992C21.6663 9.55789 21.4907 9.13397 21.1782 8.82141C20.8656 8.50885 20.4417 8.33325 19.9997 8.33325Z",
    fill: "#426F8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6663 29.9999C21.6663 29.0794 20.9201 28.3333 19.9997 28.3333C19.0792 28.3333 18.333 29.0794 18.333 29.9999C18.333 30.9204 19.0792 31.6666 19.9997 31.6666C20.9201 31.6666 21.6663 30.9204 21.6663 29.9999Z",
    fill: "#426F8C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.578df772385d4709928b8fab382f661d.svg";
export { ForwardRef as ReactComponent };